var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPdfIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5636",
    "data-name": "Group 5636",
    transform: "translate(-5002 -20539)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1993",
    "data-name": "Rectangle 1993",
    width: 70,
    height: 70,
    rx: 12.5,
    transform: "translate(5002 20539)",
    fill: "#e1e8f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "document",
    d: "M19.5,10.208V.671A10.175,10.175,0,0,1,23.095,2.99l5.081,5.084a10.141,10.141,0,0,1,2.32,3.593H20.958A1.458,1.458,0,0,1,19.5,10.208Zm11.667,5.082V27.708A7.3,7.3,0,0,1,23.875,35H9.292A7.3,7.3,0,0,1,2,27.708V7.292A7.3,7.3,0,0,1,9.292,0h6.584c.238,0,.472.019.707.035V10.208a4.375,4.375,0,0,0,4.375,4.375H31.132c.016.235.035.47.035.707ZM19.5,27.708a1.458,1.458,0,0,0-1.458-1.458H10.75a1.458,1.458,0,0,0,0,2.917h7.292A1.458,1.458,0,0,0,19.5,27.708Zm4.375-5.833a1.458,1.458,0,0,0-1.458-1.458H10.75a1.458,1.458,0,1,0,0,2.917H22.417A1.458,1.458,0,0,0,23.875,21.875Z",
    transform: "translate(5020.417 20556.5)",
    fill: "#3160d4"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfIcon);
export default __webpack_public_path__ + "static/media/PDFIcon.c8d60f80e8c1bdf618dd60b80097ebd7.svg";
export { ForwardRef as ReactComponent };